'use client';

import { Drawer } from '../../../../common/components/Drawer/Drawer';
import {
  DrawerComponent,
  useDrawerMetadata,
  useModalDrawerContext,
} from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { WithdrawalConfirmationModal } from '../WithdrawalConfirmation/WithdrawalConfirmationModal';
import { WithdrawalSummaryDrawer } from '../WithdrawalSummary/WithdrawalSummaryDrawer';
import { WithdrawalMfaContent } from './WithdrawalMfaContent';

interface WithdrawalMfaDrawerProps {
  amount: string;
  payoutAccountId: string;
  recipientName: string;
  tradeId?: string;
}

const WithdrawalMfaDrawer: DrawerComponent<WithdrawalMfaDrawerProps> = ({
  amount,
  payoutAccountId,
  recipientName,
  tradeId,
}) => {
  const { closeThisDrawer } = useDrawerMetadata();

  const { openDrawer, showModal } = useModalDrawerContext();

  const handleBack = () => {
    closeThisDrawer();

    openDrawer(WithdrawalSummaryDrawer, { amount });
  };

  const handleSuccess = ({
    amount: confirmedAmount,
    recipientName: confirmedRecipientName,
  }: {
    amount: string | null;
    recipientName: string;
  }) => {
    closeThisDrawer();

    showModal(WithdrawalConfirmationModal, {
      amount: confirmedAmount,
      recipientName: confirmedRecipientName,
    });
  };

  return (
    <Drawer hideDefaultHeader>
      <WithdrawalMfaContent
        amount={amount}
        payoutAccountId={payoutAccountId}
        recipientName={recipientName}
        onBack={handleBack}
        onSuccess={handleSuccess}
        tradeId={tradeId}
      />
    </Drawer>
  );
};

export { WithdrawalMfaDrawer };

export type { WithdrawalMfaDrawerProps };
